export const fmtMoney = (n, c = "USD") => {
  if (n == null) return "—";
  try {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: c }).format(Number(n));
  } catch {
    return `$${Number(n).toFixed(2)}`;
  }
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }); }
  catch { return iso; }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }); }
  catch { return iso; }
};

export const statusColor = (s) => {
  const map = {
    Draft: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200",
    Pending: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300",
    Active: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300",
    Completed: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300",
    Funded: "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300",
    InProgress: "bg-indigo-100 text-indigo-800 dark:bg-indigo-900/40 dark:text-indigo-300",
    Submitted: "bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-300",
    Approved: "bg-teal-100 text-teal-800 dark:bg-teal-900/40 dark:text-teal-300",
    Released: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300",
    Refunded: "bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-300",
    Split: "bg-violet-100 text-violet-800 dark:bg-violet-900/40 dark:text-violet-300",
    Disputed: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300",
    Cancelled: "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300",
    Open: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300",
    UnderReview: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300",
    Resolved: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300",
    Complete: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300",
    // Unified contract statuses
    "Awaiting acceptance": "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300",
    "Needs funding": "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300",
    "Partially funded": "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-300",
    "In progress": "bg-indigo-100 text-indigo-800 dark:bg-indigo-900/40 dark:text-indigo-300",
    "Pending approval": "bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-300",
    "Ready to release": "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300",
    "In dispute": "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300",
    // Invoice statuses
    Sent: "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300",
    Viewed: "bg-indigo-100 text-indigo-800 dark:bg-indigo-900/40 dark:text-indigo-300",
    Paid: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300",
    Overdue: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300",
  };
  return map[s] || "bg-slate-100 text-slate-700";
};

export const statusLabel = (s) => {
  // Human-readable contract/milestone status labels
  const map = {
    Pending: "Awaiting acceptance",
  };
  return map[s] || s;
};

export const milestoneStatusLabel = (m, contract) => {
  if (m?.status === "Draft" && contract && !["Pending", "Cancelled"].includes(contract.status))
    return "Needs funding";
  if (m?.status === "Released" && m?.dispute_resolution) {
    if (m.dispute_resolution === "RefundToPayer") return "Refunded";
    if (m.dispute_resolution === "Split") return "Split";
  }
  return m?.status || "";
};

export const txTypeLabel = (t) => {
  const map = {
    Fund: "Fund Escrow",
    Release: "Release Payment",
    Refund: "Refund",
    Split: "Split",
    Invoice: "Invoice paid",
  };
  return map[t] || t;
};
